// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)
export const dataAdjustmentResponse = vehicle => {
  return {
    key: vehicle.vehicleId,
    vehicle: {
      id: vehicle.vehicleId,
      photo: 
      vehicle.photo1 ||
      vehicle.photo2 ||
      vehicle.photo3 ||
      vehicle.photo4 ||
      vehicle.photo5 ||
      vehicle.photo6 ||
      vehicle.photo7 ||
      vehicle.photo8 ||
      vehicle.photo9 ||
      vehicle.photo10 || null
      ,
      brand:
        vehicle.vehicleModelId &&
        vehicle.vehicleModelId.vehicleBrandId &&
        vehicle.vehicleModelId.vehicleBrandId.brandName,
      model: vehicle.vehicleModelId && vehicle.vehicleModelId.modelName
    },
    year: vehicle.productionYear,
    registerSignAndRegion:
      (vehicle.registerSign ? vehicle.registerSign : "") +
      (vehicle.registerRegion ? vehicle.registerRegion : ""),
    passengerCapacity: vehicle.passengerCapacity,
    color: vehicle.vehicleColorId && vehicle.vehicleColorId.colorName,
    diagnosticCard: vehicle.diagnosticCardValidUntil,
    kaskoValidUntil: vehicle.kaskoValidUntil,
    osgoppValidUntil: vehicle.osgoppValidUntil,
    /*rate:
      (Array.isArray(vehicle.vehicleMonetization) &&
        vehicle.vehicleMonetization[0] &&
        vehicle.vehicleMonetization[0].usagePrice) ||
      null,*/
    rate: null,
    executors: null,
    isArchive:
      vehicle.vehicleStatusId &&
      vehicle.vehicleStatusId.vehicleStatusKey === "archive"
  };
};

// Корректирую данные для отправки
export const dataAdjustmentFiltersRequest = filters => {
  let filterData = {};
  const fields = filters.fields || {};
  const search = filters.search;

  if (fields.brand_key) {
    filterData.brand_key = fields.brand_key;
  }

  if (fields.model_key) {
    filterData.model_key = fields.model_key;
  }

  if (fields.category_key) {
    filterData.category_key = fields.category_key;
  }

  if (fields.category_key) {
    filterData.category_key = fields.category_key;
  }

  if (fields.production_year_from && fields.production_year_to) {
    filterData["production_year[from]"] = fields.production_year_from;
    filterData["production_year[to]"] = fields.production_year_to;
  }

  if (fields.passenger_capacity_from && fields.passenger_capacity_to) {
    filterData["passenger_capacity[from]"] = fields.passenger_capacity_from;
    filterData["passenger_capacity[to]"] = fields.passenger_capacity_to;
  }

  if (search) {
    filterData.search_entry = search;
  }

  return filterData;
};
